import React, { useEffect, useState } from 'react'
import ComputoAnual from './ComputoAnual'
import { useAuth } from 'context/AuthProvider'
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import { Button, Card, CardHeader, Col, FormGroup, Input, Label, Row, Table } from 'reactstrap';

const ComputoAnualImpl = () => {
    const { empresa } = useAuth();
    const [anno, setAnno] = useState(new Date().getFullYear()) 
    const [empleados, setEmpleados] = useState([])


    const [multiplicarHoras, setMultiplicarHoras] = useState(1)


    const handleCambioDiasHoras = () =>{
        if(multiplicarHoras === 8) {
            setMultiplicarHoras(1)
        }else{
            setMultiplicarHoras(8)
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiEmpleadosService.getAllFiltered(empresa.id,null, null, null, new Date().toISOString().split("T")[0], "asc", 0, 1000)
            setEmpleados(response.content);
          
        }
        fetchData();
    }, [empresa.id])
    

    

    return (
        <>
            <Card >
                <CardHeader >
                    <Row>
                        <Col >

                        <FormGroup row >
                            <Label htmlFor='anno' sm={6}>  Computo Anual de {multiplicarHoras=== 8 ? "horas" : "días"} del</Label>
                            <Col sm={4} className='ml--5' >
                                <Input id="anno" name="anno" type="number" value={anno} onChange={(e) => setAnno(e.target.value)}></Input>
                            </Col>
                        </FormGroup>
                            
                        </Col>
                        
                        <Col className='text-right ' sm={3}>
                            <Button color='primary' onClick={handleCambioDiasHoras}>Ver en {multiplicarHoras=== 8 ? "días" : "horas"}</Button>
                        </Col>
                    </Row>
                </CardHeader>
                <Table className="text-center table-flush" responsive>
                    <thead className="thead-light">
                        <tr>
                            <th className='text-left'>Empleado</th>
                            <th>Laborables</th>
                            <th>Vacaciones</th>
                            <th>Festivos</th>
                            <th>Ausencias</th>
                            <th>Bajas</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {empleados.map((empleado, index) => (
                            <tr key={index}>
                                <ComputoAnual  empleado={empleado} anno={anno} multiplicarHoras={multiplicarHoras}></ComputoAnual>
                            </tr>
                        ))}
                    </tbody>
                </Table>


            </Card>
        </>
    )
}

export default ComputoAnualImpl